import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { discharge } from "@/Services/TherapyApi/Users";

import useCustomerStore from "@/Modules/Customers/Store";
import useAppStore from "@/Modules/App/Store";

import { hasValue } from "@/Utils/Objects";

async function dischargePatientAH(reason: string): Promise<true | undefined> {
  const appStore = useAppStore();
  const customerStore = useCustomerStore();

  if (!hasValue(customerStore.selected)) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "user.settings.customer.patient_discharge.notification_error_toast",
    });

    return undefined;
  }

  const response = await discharge(customerStore.selected.id, reason).catch(() => undefined);

  if (!hasValue(response)) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "user.settings.customer.patient_discharge.notification_error_toast",
    });

    return undefined;
  }

  appStore.showSnackbar({
    type: NotificationType.INFO,
    message: "user.settings.customer.patient_discharge.notification_success_toast",
    messageParameters: { username: customerStore.selected.username },
  });

  return true;
}

export default dischargePatientAH;
